/* Dallas Sucks Coffee Company: 215 Reasons Why Dallas Sucks
   Cached as a standalone asset so the roast-of-the-day loads fast across the whole store. */
(function(){
  'use strict';
  var DSCC_215_REASONS = [
  "The phrase 'this is our year' has more mileage than a retired fleet truck.",
  "Their trophy case has entered its historical-documentary era.",
  "They treat preseason confidence like legal tender.",
  "They still think nostalgia counts on the scoreboard.",
  "Their fanbase turns September into a parade and January into witness protection.",
  "Every playoff exit comes with a fresh coat of denial.",
  "The star has fewer recent highlights than a flip phone camera roll.",
  "They invented annual disappointment with a parking pass.",
  "Their hype train runs on fumes and old VHS tapes.",
  "Even decaf has more finish.",
  "Reason 11: Dallas found a new way to make confidence look expired.",
  "Reason 12: The star shines brightest in reruns.",
  "Reason 13: Their January calendar has commitment issues.",
  "Reason 14: Philly grit beats Dallas glitter before the coffee finishes brewing.",
  "Reason 15: That fanbase talks dynasty and delivers group therapy.",
  "Reason 16: Their postseason plan is mostly vibes and emergency excuses.",
  "Reason 17: They call it tradition. We call it rerun dust.",
  "Reason 18: Even our dark roast has more rings in the modern era.",
  "Reason 19: Their swagger writes checks their fourth quarter cannot cash.",
  "Reason 20: The blue star belongs on a participation sticker.",
  "Reason 21: Every season starts with fireworks and ends with paperwork.",
  "Reason 22: Their biggest rival is the mirror in January.",
  "Reason 23: Philly wakes up angry. Dallas wakes up sponsored.",
  "Reason 24: The Cowboys are proof that branding can outrun results.",
  "Reason 25: They bring champagne expectations to boxed-juice performances.",
  "Reason 26: Dallas found a new way to make confidence look expired.",
  "Reason 27: The star shines brightest in reruns.",
  "Reason 28: Their January calendar has commitment issues.",
  "Reason 29: Philly grit beats Dallas glitter before the coffee finishes brewing.",
  "Reason 30: That fanbase talks dynasty and delivers group therapy.",
  "Reason 31: Their postseason plan is mostly vibes and emergency excuses.",
  "Reason 32: They call it tradition. We call it rerun dust.",
  "Reason 33: Even our dark roast has more rings in the modern era.",
  "Reason 34: Their swagger writes checks their fourth quarter cannot cash.",
  "Reason 35: The blue star belongs on a participation sticker.",
  "Reason 36: Every season starts with fireworks and ends with paperwork.",
  "Reason 37: Their biggest rival is the mirror in January.",
  "Reason 38: Philly wakes up angry. Dallas wakes up sponsored.",
  "Reason 39: The Cowboys are proof that branding can outrun results.",
  "Reason 40: They bring champagne expectations to boxed-juice performances.",
  "Reason 41: Dallas found a new way to make confidence look expired.",
  "Reason 42: The star shines brightest in reruns.",
  "Reason 43: Their January calendar has commitment issues.",
  "Reason 44: Philly grit beats Dallas glitter before the coffee finishes brewing.",
  "Reason 45: That fanbase talks dynasty and delivers group therapy.",
  "Reason 46: Their postseason plan is mostly vibes and emergency excuses.",
  "Reason 47: They call it tradition. We call it rerun dust.",
  "Reason 48: Even our dark roast has more rings in the modern era.",
  "Reason 49: Their swagger writes checks their fourth quarter cannot cash.",
  "Reason 50: The blue star belongs on a participation sticker.",
  "Reason 51: Every season starts with fireworks and ends with paperwork.",
  "Reason 52: Their biggest rival is the mirror in January.",
  "Reason 53: Philly wakes up angry. Dallas wakes up sponsored.",
  "Reason 54: The Cowboys are proof that branding can outrun results.",
  "Reason 55: They bring champagne expectations to boxed-juice performances.",
  "Reason 56: Dallas found a new way to make confidence look expired.",
  "Reason 57: The star shines brightest in reruns.",
  "Reason 58: Their January calendar has commitment issues.",
  "Reason 59: Philly grit beats Dallas glitter before the coffee finishes brewing.",
  "Reason 60: That fanbase talks dynasty and delivers group therapy.",
  "Reason 61: Their postseason plan is mostly vibes and emergency excuses.",
  "Reason 62: They call it tradition. We call it rerun dust.",
  "Reason 63: Even our dark roast has more rings in the modern era.",
  "Reason 64: Their swagger writes checks their fourth quarter cannot cash.",
  "Reason 65: The blue star belongs on a participation sticker.",
  "Reason 66: Every season starts with fireworks and ends with paperwork.",
  "Reason 67: Their biggest rival is the mirror in January.",
  "Reason 68: Philly wakes up angry. Dallas wakes up sponsored.",
  "Reason 69: The Cowboys are proof that branding can outrun results.",
  "Reason 70: They bring champagne expectations to boxed-juice performances.",
  "Reason 71: Dallas found a new way to make confidence look expired.",
  "Reason 72: The star shines brightest in reruns.",
  "Reason 73: Their January calendar has commitment issues.",
  "Reason 74: Philly grit beats Dallas glitter before the coffee finishes brewing.",
  "Reason 75: That fanbase talks dynasty and delivers group therapy.",
  "Reason 76: Their postseason plan is mostly vibes and emergency excuses.",
  "Reason 77: They call it tradition. We call it rerun dust.",
  "Reason 78: Even our dark roast has more rings in the modern era.",
  "Reason 79: Their swagger writes checks their fourth quarter cannot cash.",
  "Reason 80: The blue star belongs on a participation sticker.",
  "Reason 81: Every season starts with fireworks and ends with paperwork.",
  "Reason 82: Their biggest rival is the mirror in January.",
  "Reason 83: Philly wakes up angry. Dallas wakes up sponsored.",
  "Reason 84: The Cowboys are proof that branding can outrun results.",
  "Reason 85: They bring champagne expectations to boxed-juice performances.",
  "Reason 86: Dallas found a new way to make confidence look expired.",
  "Reason 87: The star shines brightest in reruns.",
  "Reason 88: Their January calendar has commitment issues.",
  "Reason 89: Philly grit beats Dallas glitter before the coffee finishes brewing.",
  "Reason 90: That fanbase talks dynasty and delivers group therapy.",
  "Reason 91: Their postseason plan is mostly vibes and emergency excuses.",
  "Reason 92: They call it tradition. We call it rerun dust.",
  "Reason 93: Even our dark roast has more rings in the modern era.",
  "Reason 94: Their swagger writes checks their fourth quarter cannot cash.",
  "Reason 95: The blue star belongs on a participation sticker.",
  "Reason 96: Every season starts with fireworks and ends with paperwork.",
  "Reason 97: Their biggest rival is the mirror in January.",
  "Reason 98: Philly wakes up angry. Dallas wakes up sponsored.",
  "Reason 99: The Cowboys are proof that branding can outrun results.",
  "Reason 100: They bring champagne expectations to boxed-juice performances.",
  "Reason 101: Dallas found a new way to make confidence look expired.",
  "Reason 102: The star shines brightest in reruns.",
  "Reason 103: Their January calendar has commitment issues.",
  "Reason 104: Philly grit beats Dallas glitter before the coffee finishes brewing.",
  "Reason 105: That fanbase talks dynasty and delivers group therapy.",
  "Reason 106: Their postseason plan is mostly vibes and emergency excuses.",
  "Reason 107: They call it tradition. We call it rerun dust.",
  "Reason 108: Even our dark roast has more rings in the modern era.",
  "Reason 109: Their swagger writes checks their fourth quarter cannot cash.",
  "Reason 110: The blue star belongs on a participation sticker.",
  "Reason 111: Every season starts with fireworks and ends with paperwork.",
  "Reason 112: Their biggest rival is the mirror in January.",
  "Reason 113: Philly wakes up angry. Dallas wakes up sponsored.",
  "Reason 114: The Cowboys are proof that branding can outrun results.",
  "Reason 115: They bring champagne expectations to boxed-juice performances.",
  "Reason 116: Dallas found a new way to make confidence look expired.",
  "Reason 117: The star shines brightest in reruns.",
  "Reason 118: Their January calendar has commitment issues.",
  "Reason 119: Philly grit beats Dallas glitter before the coffee finishes brewing.",
  "Reason 120: That fanbase talks dynasty and delivers group therapy.",
  "Reason 121: Their postseason plan is mostly vibes and emergency excuses.",
  "Reason 122: They call it tradition. We call it rerun dust.",
  "Reason 123: Even our dark roast has more rings in the modern era.",
  "Reason 124: Their swagger writes checks their fourth quarter cannot cash.",
  "Reason 125: The blue star belongs on a participation sticker.",
  "Reason 126: Every season starts with fireworks and ends with paperwork.",
  "Reason 127: Their biggest rival is the mirror in January.",
  "Reason 128: Philly wakes up angry. Dallas wakes up sponsored.",
  "Reason 129: The Cowboys are proof that branding can outrun results.",
  "Reason 130: They bring champagne expectations to boxed-juice performances.",
  "Reason 131: Dallas found a new way to make confidence look expired.",
  "Reason 132: The star shines brightest in reruns.",
  "Reason 133: Their January calendar has commitment issues.",
  "Reason 134: Philly grit beats Dallas glitter before the coffee finishes brewing.",
  "Reason 135: That fanbase talks dynasty and delivers group therapy.",
  "Reason 136: Their postseason plan is mostly vibes and emergency excuses.",
  "Reason 137: They call it tradition. We call it rerun dust.",
  "Reason 138: Even our dark roast has more rings in the modern era.",
  "Reason 139: Their swagger writes checks their fourth quarter cannot cash.",
  "Reason 140: The blue star belongs on a participation sticker.",
  "Reason 141: Every season starts with fireworks and ends with paperwork.",
  "Reason 142: Their biggest rival is the mirror in January.",
  "Reason 143: Philly wakes up angry. Dallas wakes up sponsored.",
  "Reason 144: The Cowboys are proof that branding can outrun results.",
  "Reason 145: They bring champagne expectations to boxed-juice performances.",
  "Reason 146: Dallas found a new way to make confidence look expired.",
  "Reason 147: The star shines brightest in reruns.",
  "Reason 148: Their January calendar has commitment issues.",
  "Reason 149: Philly grit beats Dallas glitter before the coffee finishes brewing.",
  "Reason 150: That fanbase talks dynasty and delivers group therapy.",
  "Reason 151: Their postseason plan is mostly vibes and emergency excuses.",
  "Reason 152: They call it tradition. We call it rerun dust.",
  "Reason 153: Even our dark roast has more rings in the modern era.",
  "Reason 154: Their swagger writes checks their fourth quarter cannot cash.",
  "Reason 155: The blue star belongs on a participation sticker.",
  "Reason 156: Every season starts with fireworks and ends with paperwork.",
  "Reason 157: Their biggest rival is the mirror in January.",
  "Reason 158: Philly wakes up angry. Dallas wakes up sponsored.",
  "Reason 159: The Cowboys are proof that branding can outrun results.",
  "Reason 160: They bring champagne expectations to boxed-juice performances.",
  "Reason 161: Dallas found a new way to make confidence look expired.",
  "Reason 162: The star shines brightest in reruns.",
  "Reason 163: Their January calendar has commitment issues.",
  "Reason 164: Philly grit beats Dallas glitter before the coffee finishes brewing.",
  "Reason 165: That fanbase talks dynasty and delivers group therapy.",
  "Reason 166: Their postseason plan is mostly vibes and emergency excuses.",
  "Reason 167: They call it tradition. We call it rerun dust.",
  "Reason 168: Even our dark roast has more rings in the modern era.",
  "Reason 169: Their swagger writes checks their fourth quarter cannot cash.",
  "Reason 170: The blue star belongs on a participation sticker.",
  "Reason 171: Every season starts with fireworks and ends with paperwork.",
  "Reason 172: Their biggest rival is the mirror in January.",
  "Reason 173: Philly wakes up angry. Dallas wakes up sponsored.",
  "Reason 174: The Cowboys are proof that branding can outrun results.",
  "Reason 175: They bring champagne expectations to boxed-juice performances.",
  "Reason 176: Dallas found a new way to make confidence look expired.",
  "Reason 177: The star shines brightest in reruns.",
  "Reason 178: Their January calendar has commitment issues.",
  "Reason 179: Philly grit beats Dallas glitter before the coffee finishes brewing.",
  "Reason 180: That fanbase talks dynasty and delivers group therapy.",
  "Reason 181: Their postseason plan is mostly vibes and emergency excuses.",
  "Reason 182: They call it tradition. We call it rerun dust.",
  "Reason 183: Even our dark roast has more rings in the modern era.",
  "Reason 184: Their swagger writes checks their fourth quarter cannot cash.",
  "Reason 185: The blue star belongs on a participation sticker.",
  "Reason 186: Every season starts with fireworks and ends with paperwork.",
  "Reason 187: Their biggest rival is the mirror in January.",
  "Reason 188: Philly wakes up angry. Dallas wakes up sponsored.",
  "Reason 189: The Cowboys are proof that branding can outrun results.",
  "Reason 190: They bring champagne expectations to boxed-juice performances.",
  "Reason 191: Dallas found a new way to make confidence look expired.",
  "Reason 192: The star shines brightest in reruns.",
  "Reason 193: Their January calendar has commitment issues.",
  "Reason 194: Philly grit beats Dallas glitter before the coffee finishes brewing.",
  "Reason 195: That fanbase talks dynasty and delivers group therapy.",
  "Reason 196: Their postseason plan is mostly vibes and emergency excuses.",
  "Reason 197: They call it tradition. We call it rerun dust.",
  "Reason 198: Even our dark roast has more rings in the modern era.",
  "Reason 199: Their swagger writes checks their fourth quarter cannot cash.",
  "Reason 200: The blue star belongs on a participation sticker.",
  "Reason 201: Every season starts with fireworks and ends with paperwork.",
  "Reason 202: Their biggest rival is the mirror in January.",
  "Reason 203: Philly wakes up angry. Dallas wakes up sponsored.",
  "Reason 204: The Cowboys are proof that branding can outrun results.",
  "Reason 205: They bring champagne expectations to boxed-juice performances.",
  "Reason 206: Dallas found a new way to make confidence look expired.",
  "Reason 207: The star shines brightest in reruns.",
  "Reason 208: Their January calendar has commitment issues.",
  "Reason 209: Philly grit beats Dallas glitter before the coffee finishes brewing.",
  "Reason 210: That fanbase talks dynasty and delivers group therapy.",
  "Reason 211: Their postseason plan is mostly vibes and emergency excuses.",
  "Reason 212: They call it tradition. We call it rerun dust.",
  "Reason 213: Even our dark roast has more rings in the modern era.",
  "Reason 214: Their swagger writes checks their fourth quarter cannot cash.",
  "Reason 215: The blue star belongs on a participation sticker."
];

  function pickReason(){
    var index = Math.floor(Math.random() * DSCC_215_REASONS.length);
    return { number: index + 1, text: DSCC_215_REASONS[index] };
  }

  function renderReason(){
    var target = document.getElementById('dscc-215-reason');
    if (!target) return;
    var reason = pickReason();
    target.innerHTML = '<b>215 Reasons Why Dallas Sucks</b> <span>Reason ' + reason.number + ':</span> ' + reason.text.replace(/^Reason\s+\d+:\s*/i, '');
    target.className += ' dscc-ready';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderReason);
  } else {
    renderReason();
  }

  window.DSCC_215_REASONS = DSCC_215_REASONS;
})();
